import $ from 'jquery'

import { createLoading } from '../meta/loading'

//
// Loader během AJAX requestu (jQuery nette-ajax).
// Aktivuje se jen tehdy, když spouštěcí element (typicky submit tlačítko)
// má v nadřazeném stromu element s atributem [data-loading].
//
// - [data-loading]            => loader se vytvoří na tomto elementu
// - [data-loading="prevent"]  => loader se nevytvoří
// - [data-loading="disable"]  => loader se nevytvoří, element se jen zamkne
//                               (pro weby, které nemají styly loaderu)
// - [data-loading-delay="ms"] => vlastní prodleva před zobrazením
//
// Pokud je elementem tlačítko/input, dostane navíc po dobu requestu atribut disabled
// (ochrana proti dvojímu odeslání).
//
// Loader navazujeme na lifecycle 'start'/'complete', takže se ukáže jen u skutečně
// odeslaného requestu (po projití client-side validace), nikdy se nezasekne.
//

if ($.nette) {
    $.nette.ext('loading', {
        start: function (xhr, settings) {
            const trigger = settings.nette && settings.nette.el ? settings.nette.el[0] : null
            const loaderEl = trigger ? trigger.closest('[data-loading]') : null

            if (!loaderEl || loaderEl.dataset.loading === 'prevent') {
                return
            }

            settings.loadingEl = loaderEl

            if (loaderEl.dataset.loading !== 'disable') {
                const options = {}
                if (loaderEl.dataset.loadingDelay) {
                    options.delay = parseInt(loaderEl.dataset.loadingDelay, 10)
                }

                settings.loading = createLoading(loaderEl, options)
                settings.loading.show()
            }

            if ('disabled' in loaderEl) {
                loaderEl.disabled = true
            }
        },

        complete: function (xhr, status, settings) {
            const loaderEl = settings.loadingEl

            if (!loaderEl) {
                return
            }

            if ('disabled' in loaderEl) {
                loaderEl.disabled = false
            }

            if (settings.loading) {
                settings.loading.destroy()
                settings.loading = null
            }

            settings.loadingEl = null
        },
    })
}
